import { List } from 'immutable';
import GoogleGtagAnalytics from 'app/services/analytics/GoogleAnalytics';

export interface IAnalyticsInstanceApiProps {
  identifyUser: (
    userId: string | undefined,
    userProperties: { [key: string]: string} | undefined,
  ) => void;
  trackPage: (page: string) => void;
}

export enum GA4UserProperties {
  CLIENT_RELEASE = 'client_release',
  USER_ROLE = 'user_role',
  ORGANIZATION = 'organization',
  BRAND = 'brand',
}

type AnalyticsAccount = {
  platform: AnalyticsPlatform,
  trackingIds: List<string>,
};

export enum AnalyticsPlatform {
  GTAG = 'gtag',
}

class AnalyticsService implements IAnalyticsInstanceApiProps {
  public analyticsInstances: readonly IAnalyticsInstanceApiProps[] = [];

  public init = (analyticsAccounts: AnalyticsAccount[]) => {
    this.analyticsInstances = analyticsAccounts.map((accountType): IAnalyticsInstanceApiProps => {
      const { platform, trackingIds } = accountType;
      switch (platform) {
        case AnalyticsPlatform.GTAG: {
          const GtagInstance = GoogleGtagAnalytics({
            trackingIds,
          });
          return GtagInstance;
        }
      }
    });
  };

  public identifyUser = (
    userId: string | undefined,
    userProperties: {[key: string]: string} | undefined,
  ) => {
    this.analyticsInstances.forEach((instance) => {
      instance?.identifyUser(userId, userProperties);
    });
  };

  public trackPage = (page: string) => {
    this.analyticsInstances.forEach((instance) => {
      instance?.trackPage(page);
    });
  };
}

export default AnalyticsService;
